var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Coming soon...")]),_c('img',{staticClass:"bow-image",attrs:{"src":require('../assets/imgs/bow.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }